export default __webpack_public_path__ + "static/media/coverPhoto.26980748.jpg";